const importModes = {
  OVERRIDE: 'override',
  APPEND:   'append',
};

export default importModes;
